import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import EngagementDetailsScreen from '@/components/EngagementDetailsScreen';



export default function CanvassEngagementDetailsScreen() {
  const { battlePlanId, engagementId } = useLocalSearchParams<{ battlePlanId: string; engagementId: string }>();

  return (
    <EngagementDetailsScreen 
      battlePlanId={battlePlanId}
      engagementId={engagementId}
      title="Voters List"
      placeholder="Search addresses, house names, numbers, or streets..."
      wakeLockId="canvassing-engagement"
      isPhoneEngagement={false}
    />
  );
}